import { Link, useLocation } from "react-router-dom";
import SchemaOrg from "@/components/base/SchemaOrg";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || "https://hackerslodge.com";

function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  const itemListElement = items.map((item, i) => ({
    "@type": "ListItem" as const,
    position: i + 1,
    name: item.label,
    ...(item.to ? { item: item.to.startsWith("http") ? item.to : `${siteUrl}${item.to}` } : {}),
  }));

  if (itemListElement.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = buildBreadcrumbSchema(items);

  return (
    <>
      {schema && <SchemaOrg data={schema} />}
      <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-gray-400 mb-6">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <i className="fas fa-chevron-right text-[10px]" aria-hidden="true" />}
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-[#5bc0de] transition-colors font-medium"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-500" aria-current="page">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}